import { Divider, Button, Breadcrumb, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import { VisitorComponent } from "./FormComponent";
import { useMediaQuery } from "react-responsive";
import { LanguageContext } from "../../../context/Language.contex";
import { useContext } from "react";

export const FormVisitor = () => {
  //   const { user } = useContext(UserContext);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  return (
    <div
      className="wrapper"
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        justifyContent: "space-evenly",
      }}
    >
      <div className="navbar">
        <Breadcrumb
          style={{ margin: isMobile ? "30px 0 0 10px" : "30px 0 0 100px" }}
        >
          <Breadcrumb.Item>
            <a
              onClick={() => {
                navigate("/");
              }}
            >
              Home
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{language[12]}</Breadcrumb.Item>
        </Breadcrumb>

        <Layout style={{ background: "white" }}>
          <div className="login-area">
            <VisitorComponent />
          </div>
        </Layout>
      </div>

      <div className="footers">{/* <Footers /> */}</div>
    </div>
  );
};
